// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQueryResult } from 'lib/graphql/graphqlTypes'
// @libraries
import strings from 'lib/constants/strings'
// @components
import Banner from '@bit/atd.web.banner'
import icons from '@bit/atd.web.icons/getIcons'

const PublicProfileBanner = ({
  userData,
}: {
  userData?: GetUserQueryResult['data']
}): ReactElement => {
  /****************************************
   * PROPS
   *****************************************/

  const isProfileVisible = userData?.user?.visibility.publicProfile
  const privacyNoticeText: {
    icon: keyof typeof icons
    title: string
    body: string
  } = isProfileVisible
    ? {
        icon: 'lock-off',
        title: strings.PROFILE.BIO.PROFILE_IS_ON,
        body: strings.PROFILE.BIO.VISIBILITY_AVAILABLE_WARNING,
      }
    : {
        icon: 'lock-on',
        title: 'Your Public Profile is OFF',
        body: 'The following will be not visible to other users',
      }

  /****************************************
   * RENDER
   *****************************************/

  return (
    <Banner
      fullWidth
      icon={privacyNoticeText.icon}
      header={privacyNoticeText.title}
    >
      {privacyNoticeText.body}:
    </Banner>
  )
}

export default PublicProfileBanner
